import { PersonaConfig, PersonaOrder, OrderStatus } from "../types";

// KnitWell / Ann Taylor WISMO demo — a single seeded test caller (John Mike)
// with the five recent order ids from the client-experience brief. The agent
// looks orders up live on the backend; this is just the picker + CRM context.
export interface KnitwellCustomer {
  id: string;
  name: string;
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
  loyaltyTier: string;
  crmNotes: string;
  ordersCount: number;
  demoScenario?: string;
  orders: { orderId: string; product: string; status: string; date?: string }[];
}

const ORDER_IDS = ["1161120841", "1161120636", "1161120639", "1161120638", "220000934614"];

export const KNITWELL_CUSTOMERS: KnitwellCustomer[] = [
  {
    id: "JOHNMIKE",
    name: "John Mike",
    firstName: "John",
    lastName: "Mike",
    email: "",
    phone: "6157675101",
    loyaltyTier: "Member",
    crmNotes: "WISMO test caller — five recent Ann Taylor orders on file.",
    ordersCount: ORDER_IDS.length,
    demoScenario: "wismo",
    orders: ORDER_IDS.map((id, i) => ({
      orderId: id,
      product: "Ann Taylor order",
      status: i === 0 ? "in_transit" : "delivered",
    })),
  },
];

export const KNITWELL_PERSONA_ID_PREFIX = "knit_";

export function getKnitwellCustomer(id: string): KnitwellCustomer | undefined {
  return KNITWELL_CUSTOMERS.find((c) => c.id === id);
}

export function knitwellCustomerToPersona(c: KnitwellCustomer): PersonaConfig {
  return {
    id: `${KNITWELL_PERSONA_ID_PREFIX}${c.id}`,
    name: c.name,
    role: c.crmNotes || "Customer",
    avatarInitials: ((c.firstName[0] ?? "") + (c.lastName[0] ?? "")).toUpperCase(),
    avatarBg: "",
    tagLine: c.crmNotes,
    email: c.email,
    phone: c.phone,
    accountId: c.id,
    memberSince: "",
    loyaltyTier: c.loyaltyTier,
    orders: c.orders.map((o): PersonaOrder => ({
      orderId: o.orderId,
      product: o.product,
      status: o.status as OrderStatus,
      date: o.date ?? "",
    })),
    ordersCount: c.ordersCount,
    bestFor: [],
    suggestedQuestions: {},
    crmNotes: c.crmNotes,
  };
}
